module.exports = __webpack_public_path__ + "media/icons/skrzynia-automatyczna-grey@2x-8c2d1fc0.png";